<template>
    <div>
        <div v-if="type == 'query'" class="button-container margin-bottom-10">
            <Button type="primary" @click="handleQueryUpload">附件上传</Button>
        </div>
        <compWrapper title="刷屏资源信息" theme="primary">
			<compFormQuery v-if="type=='query'" :formdata="getBase" :value="formData" :labelWidth="120"></compFormQuery>
			<compFormEdit v-else class="margin-15 clearfix" ref="editform" :formdata="getBase" v-model="formData" :labelWidth="120" />
        </compWrapper>
        <compWrapper :title="$t('fbb.headlogistics.attach_upload', { defaultValue: '附件上传' })" theme="success">
            <!-- <compUpload v-bind="getFileProps"></compUpload> -->
            <div v-if="type != 'query'" class="margin-top-15 margin-left-15">
                <Button class="margin-right-15" type="primary" @click="uploadAttach">{{$t('fbb.headlogistics.attach_upload', { defaultValue: '附件上传' })}}</Button>
                <!-- <span class="color-error">最多上传5个附件</span> -->
            </div>
            <Table class="margin-layout" :columns="attachColumns" :data="attachData" border size="small"></Table>
        </compWrapper>
        <div v-if="type!='query'" class="text-right margin-right-15">
            <vButton theme="primary" @click="submit()">保存</vButton>
            <vButton class="margin-left-10" @click="cancel">{{$t('global.common.operate_cancel',{defaultValue:'取消'})}}</vButton>
        </div>
        <compModal v-model="operate.show" v-bind="operate">
            <component :is="operate.component" v-bind="operate" v-on="operate.on"></component>
        </compModal>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>

import { mapState,mapGetters,mapMutations } from "vuex";
import {
    HttpGetBrushReviewOne,
    HttpSaveBrushReview,
    HttpDelAttachNew,
    HttpBatchUploadMeta
} from "@/service/products/brushreview";
import compBatchUpload from "./upload";
export default {
    props:['activeids','querytype'],
    components: {
        compBatchUpload,
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
	},

    data(){
        return {
            id: this.$route.query.id,
            type: this.$route.params.type,
            formData:{},
            operate: {
                show: false
            },
            attachData: [],
            loading: false
        }
    },

    created(){
        this.update()
    },

    computed:{
    ...mapGetters('diction',['getAllProductPerson']),
    ...mapGetters('dictionary',['getCountryList']),

        getBase(){
        let showquery = this.type == 'query'
            return [
                {
					label: '负责人',
                    key: "manageId",
                    tag: "vSelect",
                    options: this.getAllProductPerson.map((item) => {
                        return {
                            value: item.attach.id,
                            label: item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                },
                {
					label: '姓名',
					key: "name",
				},
                {
                    label: '个人link',
                    key: "link",
                },
                {
					label: 'email',
                    key: "email",
				},
                {
                    label: 'amazon profile',
                    key: "amazonProfile",
                },
                {
                    label: '来源渠道',
                    key: "sourceAccount",
                    props: {
                            filterable: true,
                    },
                    tag: "vSelect",
                    options: [
                            {
                                value: '微信',
                                label: '微信'
                            },
                            {
                                value: 'facebook',
                                label: 'facebook'
                            },
                            {
                                value: 'email',
                                label: 'email'
                            },
                            {
                                value: 'testzon',
                                label: 'testzon'
                            },
                            {
                                value: '朋友介绍',
                                label: '朋友介绍'
                            },
                            {
                                value: '其他',
                                label: '其他'
                            },
                        ],
                },
                {
                    label: '国别',
                    key: "country",
                    tag: "vSelect",
                    options: this.getCountryList.map((item) => {
                          return {
                              value: item.value,
                              label: item.label
                          }
                    }),
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: '开始合作时间',
                    key: "beginTime",
                    tag:"vDatepicker",
                    required: false,
                    props: {
                        format: 'yyyy-mm-dd',
                    }
                },
                {
                    label: '备注',
                    key: "remark",
                    required: false,
                },
            ]
        },
        attachColumns () {
            let columns = [
                {
                    title: "附件名称",
                    key: "attachBrief"
                },
                {
                    title: "附件链接",
                    key: "attachUrl",
                    render: (h, { row }) => {
                        return <a href={row.attachUrl} target="_blank">{row.attachUrl}</a>
                    }
                },
                {
                    title: "操作",
                    align: "center",
                    render: (h, { row, index }) => {
                        return (
                            <div>
                                <Button size="small" onClick={this.remove.bind(this, row, index)}>删除</Button>
                            </div>
                        );
                    }
                }
            ];
            if (this.type == "query") {
                columns.splice(columns.length - 1, 1);
            }
            return columns;
        },
    },
    methods:{
        ...mapMutations('diction', ['clearStore']),
        handleQueryUpload () {
            this.operate = {
                show: true,
                title: "附件上传",
                width: 450,
                component: "compBatchUpload",
                id: this.id,
                showFooter: false,
                on: {
                    "on-update": () => {
                        this.update();
                        this.operate = { show: false };
                    },
                    "on-close": () => {
                        this.operate = { show: false };
                    }
                }
            };
        },
        uploadAttach () {
            this.operate = {
                show: true,
                title: "添加附件",
                width: 460,
                component: "compMutiUpload",
                data: {
                    srcLabel: this.id || 0,
                    model: "brushreview_resource",
                    type: "other",
                },
                showFooter: false,
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                multiple: true,
                beforeUpload: (fileList) => {
                    // if (fileList.length > 5) {
                    //     this.$VMessage.error("附件数量过多，请打包后上传");
                    //     return false;
                    // } else {
                    //     return true;
                    // }
                    return true;
                },
                on: {
                    "on-success": (res) => {
                        res.items.map(item => {
                            this.attachData.push(item);
                        });
                        this.operate = {};
                    },
                    "on-cancel": () => {
                        this.operate = {};
                    },
                },
            };
        },
        async remove(row, index) {
            // 新增时删除附件用另外的接口
            this.loading = true;
            await HttpDelAttachNew({
                id: row.attachId
            }).then(
                (res) => {
                    if (this.type != 'edit') {
                        this.$VMessage.success(res.message);
                    }
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            ).finally(() => {
                this.attachData.splice(index, 1);
            });

            // 编辑时需要调用保存接口上传
            if (this.type == 'edit') {
                
                let fileList = this.attachData.length ? this.attachData.map(item => {
                    return {
                        id: this.id,
                        fileName: item.attachBrief,
                        meta: JSON.stringify({
                            items: [item],
                            opAt: item.attachOpAt,
                            organizationId: global.SYSID,
                        })
                    }
                }) :
                [
                    {
                        id: this.id,
                        fileName: "",
                        meta: JSON.stringify({})
                    }
                ];
                await HttpBatchUploadMeta({
                    contextId: global.SYSID,
                    type: 0,
                    items: fileList
                }).then(
                    (res) => {
                        this.attachData.splice(index, 1);
                        this.$VMessage.success(res.message);
                    },
                    (err) => {
                        if (!useId) {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true,
                            });
                        }
                    }
                );
                this.loading = false;
            }
            else {
                this.loading = false;
            }
        },
        update(){
            if(this.type == 'add') return
            if(this.activeids){
                this.id = this.activeids
                this.type = this.querytype
            }else{
                this.id = this.id
                this.type = this.type
            }
            HttpGetBrushReviewOne({
                id:this.id
            }).then(res=>{
                this.formData = res.data;
                this.attachData = res.data.meta ? JSON.parse(res.data.meta).items : [];
            },err=>{
                this.$VMessage.error(err.message);
            })
        },
        async submit(){
            let bool3 = await this.$refs.editform.validate();
            if(!bool3){
                return
            }
            let meta = JSON.stringify({
                items: this.attachData,
                opAt: this.attachData[0]
                    ? this.attachData[0].attachOpAt
                    : "",
                organizationId: global.SYSID,
            });
            HttpSaveBrushReview({
                ...this.formData,
                meta,
                orgId:global.SYSID,
            }).then(res=>{
                this.$VMessage.success(res.message)
                this.cancel()
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            this.$router.push({
                name: 'brushReviewList',
            });
        }
    },
}
</script>
